import React, { Component, Fragment } from "react";
import OrganizationsEditorModal from "./OrganizationsEditorModal";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";
import AddAreasModal from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageOne/AddAreasModal";
import OrganizationsBGImg from "./images.jpg";

class Organizations extends Component {
  state = {
    editQuadrantFormData: null,
    originalEditQuadrantFormData: null,
    oldQuadrantData: [],
    oldEditForm: [],
    selectedQuadrantNumber: null,
    titleEdit: false,
    maxMainTitleLength: 50,
    addAreasModalOpen: false,
    filteredAreas: {},
    maxMainSubtitleLength: 70,
    savingMessageShowing: false,
  };

  handleFormClose = (quadNum) => {
    const { organizationsDetails, currentArea } = this.props;
    const { editQuadrantFormData, oldQuadrantData, oldEditForm } = this.state;

    let foundIndex = oldQuadrantData.findIndex(
      (x) => x.bpciAreaID == editQuadrantFormData.bpciAreaID,
    );
    this.setState(
      {
        titleEdit: false,
        addAreasModalOpen: false,
        savingMessageShowing: false,
        editQuadrantFormData: oldEditForm,
      },
      () => {
        this.props.setVolunteerDetails(oldQuadrantData);
      },
    );

    let newObj = [...organizationsDetails]
      .filter((quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];

    let thisObj = [...organizationsDetails]
      .filter((quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];

    this.setState({
      oldQuadrantData: [...organizationsDetails].map((i) => ({ ...i })),
      editQuadrantFormData: [...organizationsDetails]
        .filter(
          (quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID,
        )
        .map((i) => ({ ...i }))[0],
    });

    this.props.updateQuadrantModalOpen(false);
  };
  onEditFormSubmit = () => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;
    let foundIndex = oldQuadrantData.findIndex(
      (x) => x.bpciAreaID == editQuadrantFormData.bpciAreaID,
    );
    oldQuadrantData[foundIndex] = editQuadrantFormData;
    this.props.setVolunteerDetails(oldQuadrantData);
    this.props.updateQuadrantModalOpen(false);

    // this.setState({
    //   savingMessageShowing: true,
    // });
    //
    // setInterval(() => {
    //   this.setState({ savingMessageShowing: false });
    //   this.props.updateQuadrantModalOpen(false);
    // }, 5000);

    // console.log("oldQuadrantData", oldQuadrantData);
  };
  openSelectedQuadrant = (quadrantNumber, titleEdit) => {
    const { editQuadrantFormData, oldQuadrantData, oldEditForm } = this.state;

    let foundIndex = oldQuadrantData
      .slice()
      .findIndex((x) => x.bpciAreaID == editQuadrantFormData.bpciAreaID);
    let currentOldData = oldQuadrantData.slice()[foundIndex];

    this.setState(
      {
        selectedQuadrantNumber: quadrantNumber,
        titleEdit: titleEdit,

        savingMessageShowing: false,
        oldEditForm: currentOldData,
      },
      () => {
        this.props.updateQuadrantModalOpen(true);
      },
    );
  };
  componentDidMount = () => {
    require("./print.scss");
    if (this.props.fromEditor) {
      require("./editor.scss");
    }

    const { organizationsDetails, currentArea } = this.props;

    this.props.updateQuadrantModalOpen(false);

    let newObj = [...organizationsDetails]
      .filter((quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];

    if (!newObj && currentArea.mlsAreaID.includes("DEMO")) {
      newObj = organizationsDetails[0];
    }
    let includesDemo = currentArea.mlsAreaID.includes("DEMO");
    // console.log("includesDemo", includesDemo);
    // console.log("newObj", newObj);
    let thisObj = [...organizationsDetails]
      .filter((quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];
    this.setState({
      oldQuadrantData: [...organizationsDetails].map((i) => ({ ...i })),
      editQuadrantFormData: [...organizationsDetails]
        .filter(
          (quadrantObj) => quadrantObj.bpciAreaID === currentArea.mlsAreaID,
        )
        .map((i) => ({ ...i }))[0],
    });
    // if (!this.state.editQuadrantFormData) {
    //   console.log("no edit");
    //   this.setState({
    //     editQuadrantFormData: organizationsDetails[0],
    //   });
    // }
    //  console.log("after mounting", this.state);
    // this.setState({
    //   oldQuadrantData: organizationsDetails,
    //   editQuadrantFormData: organizationsDetails,
    // });
  };
  handleRestoreDefault = () => {
    const {
      selectedQuadrantNumber,
      editQuadrantFormData,
      oldQuadrantData,
      titleEdit,
    } = this.state;
    let past = oldQuadrantData[selectedQuadrantNumber];
    if (titleEdit) {
      this.setState({
        // mainTitle: oldTitle,
        // subtitle: oldSubtitle,
      });
    } else if (selectedQuadrantNumber >= 0) {
      let newObj = [...editQuadrantFormData].map((i) => ({ ...i }));
      // console.log("regular obj", newObj);
      let oldSelection = [...oldQuadrantData].map((i) => ({
        ...i,
      }))[selectedQuadrantNumber];
      // console.log("oldSelection", oldSelection);
      newObj[selectedQuadrantNumber].text = oldSelection.text;
      // console.log("after obj", newObj);
      this.setState({
        editQuadrantFormData: newObj,
      });
    }
  };
  handleInputChange = (e) => {
    const { editQuadrantFormData, oldQuadrantData, titleEdit, oldEditForm } =
      this.state;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    // console.log("target", target);
    // console.log("value", value);
    // console.log("name", name);

    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [name]: value,
    });

    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  selectOrganizationText = (organization, selectedQuadrantNumber) => {
    const { editQuadrantFormData } = this.state;
    const { bpciText, bpciHeader, bpciFooter } = organization;
    let titleToChange = `bpciHeading${selectedQuadrantNumber}`;
    let textToChange = `bpciText${selectedQuadrantNumber}`;
    let websiteURLToChange = `bpciFooter${selectedQuadrantNumber}`;

    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [titleToChange]: bpciHeader,
      [textToChange]: bpciText,
      [websiteURLToChange]: bpciFooter,
    });

    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  applyToAllAreas = () => {
    console.log("applyToAllAreas");
  };

  render() {
    // console.log(this.props.currentArea);
    const { mlsAreaID } = this.props.currentArea;
    const {
      mlsAreas,
      quadrantModalOpen,
      currentArea,
      fromEditor,
      hoData,
      agentData,
      altAgentData,
    } = this.props;
    const { listgenUserID } = agentData;
    //console.log("quadrantModalOpen", quadrantModalOpen);

    const {
      openSelectedQuadrant,
      handleInputChange,
      handleRestoreDefault,
      applyToAllAreas,
      selectOrganizationText,
    } = this;
    const {
      editQuadrantFormData,
      oldQuadrantData,
      selectedQuadrantNumber,

      titleEdit,

      addAreasModalOpen,
      maxMainTitleLength,
      maxMainSubtitleLength,
      savingMessageShowing,
    } = this.state;
    let subtitleStyles;
    if (
      mlsAreaID === "SCL-207A" ||
      mlsAreaID === "SCL-207B" ||
      mlsAreaID === "SCL-209A" ||
      mlsAreaID == "SCL-209B"
    ) {
      subtitleStyles = "no-capitalized-subtitle";
    }
    let quadrantStyles;

    // else if (
    //   editQuadrantFormData &&
    //   editQuadrantFormData.bpciText4 &&
    //   editQuadrantFormData.bpciText4.length > 250
    // ) {
    //   console.log("bpciText4");
    // }
    // console.log("quadrant state", this.state);

    // let showButtons = true;
    const { showAllEditButtons } = this.props;
    let showButtons = fromEditor && showAllEditButtons;
    let showFooter = true;

    if (listgenUserID === "102413" || listgenUserID === "104835") {
      showFooter = false;
    }
    // let showButtons = currentArea.mailingStatus !== "Approved";

    if (editQuadrantFormData && Object.keys(editQuadrantFormData).length >= 1) {
      const {
        bpciAreaID,
        bpciAreaTitle,
        bpciAreaSubTitle,
        bpciHeading1,
        bpciText1,
        bpciHeading2,
        bpciText2,
        bpciHeading3,
        bpciText3,
        bpciHeading4,
        bpciText4,
      } = editQuadrantFormData;

      let separateLineWebsite = false;
      // if (listgenUserID === "109788" || listgenUserID === "102527") {
      //   separateLineWebsite = true;
      // }

      return (
        <Fragment>
          {addAreasModalOpen && (
            <AddAreasModal
              addAreasModalOpen={addAreasModalOpen}
              mlsAreas={mlsAreas}
              currentArea={currentArea}
              onCloseFn={this.handleFormClose}
              onEditFormSubmit={this.onEditFormSubmit}
              editQuadrantFormData={editQuadrantFormData}
            />
          )}
          {editQuadrantFormData &&
            Object.keys(editQuadrantFormData).length >= 1 &&
            quadrantModalOpen &&
            fromEditor && (
              <OrganizationsEditorModal
                oldQuadrantData={oldQuadrantData}
                onCloseFn={this.handleFormClose}
                handleInputChange={handleInputChange}
                editQuadrantFormData={editQuadrantFormData}
                onEditFormSubmit={this.onEditFormSubmit}
                selectedQuadrantNumber={selectedQuadrantNumber}
                handleRestoreDefault={handleRestoreDefault}
                titleEdit={titleEdit}
                mlsAreas={mlsAreas}
                maxMainTitleLength={maxMainTitleLength}
                maxMainSubtitleLength={maxMainSubtitleLength}
                savingMessageShowing={savingMessageShowing}
                selectOrganizationText={selectOrganizationText}
                currentArea={currentArea}
                agentData={agentData}
                altAgentData={altAgentData}
                fromEditor={fromEditor}
              />
            )}

          <div
            className={`print-organizations-container ${
              fromEditor ? "from-editor-mode" : ""
            } ${quadrantStyles && quadrantStyles} `}
          >
            {fromEditor && showButtons && (
              <>
                <div
                  className="organizations-btn organizations-title-btn"
                  onClick={() => openSelectedQuadrant(null, true)}
                >
                  <div>Edit Header</div>
                </div>

                <div
                  className="organizations-btn organizations-btn-1"
                  onClick={() => openSelectedQuadrant(1)}
                >
                  <div>Edit Section</div>
                </div>

                <div
                  className="organizations-btn organizations-btn-2"
                  onClick={() => openSelectedQuadrant(2)}
                >
                  <div>Edit Section</div>
                </div>

                <div
                  className="organizations-btn organizations-btn-3"
                  onClick={() => openSelectedQuadrant(3)}
                >
                  <div>Edit Section</div>
                </div>

                <div
                  className="organizations-btn organizations-btn-4"
                  onClick={() => openSelectedQuadrant(4)}
                >
                  <div>Edit Section</div>
                </div>
              </>
            )}
            <img
              className="organizations-bg-img"
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/101926_PMA-BackCover.png"
            />
            <div className="organizations">
              <div className="organizations-title-container">
                <div
                  className="organizations-title-text"
                  dangerouslySetInnerHTML={{ __html: bpciAreaTitle }}
                ></div>
              </div>

              <div className="organizations-body">
                <div className="section-container">
                  <div className="section-row">
                    {[0, 1, 2, 3].map((quadrant, i) => {
                      let index = i + 1;

                      let quadNumTitle =
                        editQuadrantFormData[`bpciHeading${index}`];
                      let quadNumText =
                        editQuadrantFormData[`bpciText${index}`];
                      let quadWebsiteURL =
                        editQuadrantFormData[`bpciFooter${index}`];
                      return (
                        <div
                          className={`${
                            index == selectedQuadrantNumber &&
                            "selected-organizations-section"
                          } organizations-section section-${index}`}
                          key={index}
                        >
                          <div className="organizations-section-title-and-text">
                            <p className="organizations-section-title">
                              {quadNumTitle}
                            </p>
                            {separateLineWebsite ? (
                              <>
                                <p className="organizations-section-text">
                                  {quadNumText}{" "}
                                </p>
                                <p className="organizations-section-websiteURL centered-website-url">
                                  {quadWebsiteURL}
                                </p>
                              </>
                            ) : (
                              <p className="organizations-section-text">
                                {quadNumText}{" "}
                                <span className="organizations-section-websiteURL">
                                  {quadWebsiteURL}
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return <div>Loading...</div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    quadrantModalOpen: state.pma.quadrantModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateQuadrantModalOpen: (isModalOpen) => {
      dispatch(pmaActions.updateQuadrantModalOpen(isModalOpen));
    },
    setVolunteerDetails: (organizationsDetails) => {
      dispatch(pmaActions.setVolunteerDetails(organizationsDetails));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Organizations);
